'use client';

import React from 'react';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import BalancedContentSection from '@/components/sections/BalancedContentSection/BalancedContentSection';
import { RichTextSection } from '@/features/aboutUs/hooks/types';

type OurVisionCardProps = {
  label: RichTextSection;
  description: RichTextSection;
  subtitle?: { content: string; styles?: Record<string, string> };
  imgUrl?: string;
  imgTitle?: string;
  textPosition: 'left' | 'right';
};

const OurVisionCard: React.FC<OurVisionCardProps> = ({
  imgUrl,
  imgTitle,
  textPosition,
  label,
  description,
}) => {
  const data = {
    textPosition,
    backgroundColor: 'bg-transparent',
    imageRatio: 'lg:w-1/2' as const,
  };

  const mediaContent = (
    <div className="overflow-hidden rounded-lg">
      <R2Image
        path={imgUrl}
        width={604}
        alt={imgTitle || 'vision image'}
        height={411}
        className="h-102.75 w-full rounded-lg object-cover lg:w-151 lg:min-w-151"
        sizes="(min-width: 611px) 611px, 100vw"
      />
    </div>
  );

  const textContent = (
    <>
      <RichText
        styles={
          label?.styles || {
            p: 'text-h3 font-bold text-royal-500 m-0',
            em: 'not-italic text-royal-875 text-body font-bold',
          }
        }
        className="mb-3"
      >
        {label?.content}
      </RichText>
      <RichText
        styles={
          description?.styles || {
            p: 'text-body text-text-body-dark mb-4',
          }
        }
      >
        {description?.content}
      </RichText>
    </>
  );

  return (
    <BalancedContentSection
      data={data}
      mediaContent={mediaContent}
      textContent={textContent}
      containerClassName=""
    />
  );
};

export default OurVisionCard;
